import OverlayWindow from 'Components/OverlayWindow';
import DropdownActionItem from 'Components/Popups/DropdownActions/DropdownActionItem';
import { useAuth } from 'utils/AuthProvider';
import useActions from './useActions';
import { BulkDownloadModal, useBulkDownloadModal } from './BulkDownloadModal';

export default function ActionsPopup() {
  const {
    viewDetails,
    deleteNode,
    move,
    share,
    createNode,
    downloadDocument,
    type,
    copyFolder,
    node,
    canAdd,
    canCopy,
    canDelete,
    canMove,
    canRestore,
    canMoveToTrash,
    isOwner,
    moveToTrash,
    restore,
    canShare,
  } = useActions();
  const BulkModal = useBulkDownloadModal();

  return (
    <OverlayWindow paddingSize="" size="" rounded="">
      <DropdownActionItem.Details onClick={viewDetails} />

      {type === 'document' && node.file_url && (
        <DropdownActionItem.Download onClick={downloadDocument} />
      )}

      {type === 'document' && !node.file_url && (
        <DropdownActionItem.CorruptedDownload onClick={downloadDocument} />
      )}

      {type === 'folder' && (
        <DropdownActionItem.DownloadFolder
          onClick={() =>
            BulkModal.openWithContext({
              data: { id: node.id, title: node.title },
            })
          }
        />
      )}

      {isOwner && (
        <>
          <hr />
          {canDelete && <DropdownActionItem.Delete onClick={deleteNode} />}
          {canMoveToTrash && (
            <DropdownActionItem.MoveToTrash onClick={moveToTrash} />
          )}
          {canRestore && <DropdownActionItem.Restore onClick={restore} />}
          {canMove && <DropdownActionItem.MoveTo onClick={move} />}
          {canShare && <DropdownActionItem.Share onClick={share} />}
          {type === 'folder' && (
            <>
              {canAdd && (
                <>
                  <hr />
                  <DropdownActionItem.NewDocument
                    onClick={createNode('document')}
                  />
                </>
              )}

              {canCopy && (
                <>
                  <hr />
                  <DropdownActionItem.CopyFolder onClick={copyFolder} />
                </>
              )}
            </>
          )}
        </>
      )}
      <BulkModal.Component>
        <BulkDownloadModal />
      </BulkModal.Component>
    </OverlayWindow>
  );
}
